<!-- Add Toast for messages and ConfirmPopup for deletion -->
<p-toast></p-toast>
<p-confirmPopup></p-confirmPopup>

<div class="projects-container">
  <h2>Your Projects</h2>
  <!-- Keyboard navigation indicator for accessibility -->
  <div class="keyboard-focus" [class.visible]="keyboardFocusVisible">
    Press Tab to navigate, Enter to select
  </div>

  <!-- Enhanced Loading Indicator -->
  <div *ngIf="isLoading" class="loading-indicator animate-fade-in">
    <p-progressSpinner styleClass="w-5rem h-5rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
    <p>Loading your projects...</p>
  </div>

  <!-- Error Message (Handled by p-toast, but keep a placeholder if needed) -->
  <div *ngIf="error && !isLoading" class="error-message p-message p-message-error my-3 animate-fade-in">
     <span class="p-message-icon pi pi-exclamation-triangle"></span>
     <span class="p-message-text">{{ error }}</span>
  </div>

  <!-- Projects List -->
  <div class="animate-fade-in">
    <!-- Filter Section Re-added (Search Only) -->
    <app-list-filter
      *ngIf="(projects$ | async)?.length"
      [searchTerm]="searchTerm"
      (searchTermChange)="searchTerm = $event; filterProjects()"
      [itemCount]="filteredProjects.length"
      itemLabel="project"
      itemLabelPlural="projects"
      placeholder="Search by name or description..."
      createButtonLabel="New Project"
      (createClicked)="openCreateProjectDialog()">
    </app-list-filter>

    <!-- Show projects if available -->
    <div *ngIf="!isLoading && !error && (projects$ | async)?.length > 0">
      <div class="p-grid projects-grid"> <!-- Use p-grid for PrimeFlex v2 -->
        <!-- Project Cards (Always 3-column layout - PrimeFlex v2 classes) -->
        <div *ngFor="let project of filteredProjects; let i = index" class="p-col-12 p-md-6 p-lg-4" [style.--animation-order]="i">
           <div class="project-card-container">
              <!-- Custom card implementation -->
              <div class="custom-project-card" tabindex="0">
                 <!-- Three dots button in top right corner -->
                 <div class="card-menu-button" [class.menu-open]="openMenuIndex === i">
                    <button pButton pRipple
                            type="button"
                            icon="pi pi-ellipsis-v"
                            class="p-button-text p-button-sm dropdown-trigger"
                            (click)="toggleCustomMenu($event, i)"
                            aria-label="More actions">
                    </button>
                    
                    <!-- Custom dropdown menu -->
                    <div class="custom-dropdown-menu"
                         *ngIf="openMenuIndex === i"
                         (click)="$event.stopPropagation()">
                       <div class="menu-item" (click)="editProject(project)">
                          <i class="pi pi-pencil"></i>
                          <span>Edit</span>
                       </div>
                       <div class="menu-item delete-item" (click)="confirmDeleteProject(project)">
                          <i class="pi pi-trash"></i>
                          <span>Delete</span>
                       </div>
                    </div>
                 </div>
                 
                 <!-- Card header -->
                 <div class="card-header">
                    <h3 class="card-title">{{ project.name }}</h3>
                    <p class="card-description">{{ project.description || 'No description' }}</p>
                 </div>
                 
                 <!-- Card content area -->
                 <div class="card-content">
                    <!-- Additional content can go here if needed -->
                 </div>
              </div>
              
              <!-- Action buttons as card extensions -->
              <div class="card-action-buttons">
                 <button pButton pRipple
                         type="button"
                         icon="pi pi-eye"
                         label="View"
                         class="p-button-outlined view-button"
                         (click)="navigateToProjectExperiences(project.id)"
                         aria-label="View project experiences">
                 </button>
                 <button pButton pRipple
                         type="button"
                         icon="pi pi-chart-line"
                         label="Analytics"
                         class="p-button-outlined analytics-button"
                         (click)="navigateToProjectAnalytics(project.id, project.name)"
                         aria-label="View project analytics">
                 </button>
              </div>
           </div>
        </div>
      </div>
    </div>

    <!-- Enhanced No Projects Template -->
    <div *ngIf="!isLoading && !error && !(projects$ | async)?.length" class="no-projects-message animate-fade-in" style="display: flex; justify-content: center;">
      <div class="text-center" style="max-width: 500px; margin: 4rem auto; padding: 2.5rem; background: linear-gradient(135deg, #ffffff 0%, rgba(255, 251, 243, 0.9) 100%); border-radius: 12px; box-shadow: 0 4px 12px rgba(72, 65, 84, 0.15); text-align: center; display: flex; flex-direction: column; align-items: center; border: 1px solid rgba(72, 65, 84, 0.08);">
        <!-- Decorative icon with theme colors -->
        <i class="pi pi-folder-open" style="font-size: 4.5rem; color: #F2D16D; margin-bottom: 1.5rem; display: block; filter: drop-shadow(0 2px 4px rgba(242, 209, 109, 0.3));"></i>
        
        <!-- Updated styling to match theme -->
        <h3 style="font-size: 2.5rem; font-weight: 700; margin-bottom: 1rem; color: #484154;">No projects yet!</h3>
        
        <!-- Updated text color -->
        <p style="font-size: 1.25rem; color: #6c757d; margin-bottom: 2rem; font-weight: 500;">Ready to start creating amazing experiences?</p>
        
        <!-- Enhanced button styling -->
        <button pButton pRipple
                label="Create Your First Project"
                icon="pi pi-plus"
                class="p-button-lg"
                style="background: linear-gradient(135deg, #F2D16D 0%, #e6c061 100%); border: none; color: #484154; font-weight: 600; padding: 0.875rem 1.75rem; border-radius: 8px; box-shadow: 0 4px 12px rgba(242, 209, 109, 0.4); transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);"
                (click)="openCreateProjectDialog()">
        </button>
      </div>
    </div>
    </div>
</div>
